const waitForElement = setInterval(() => {
  const target = document.querySelector("#CartDrawer");
  if (target) {
    clearInterval(waitForElement);

const observer = new MutationObserver((mutations) => {
  mutations.forEach((mutation) => {
    if (
      mutation.type === "attributes" &&
      mutation.attributeName === "class"
    ) {
      if (target.classList.contains("drawer--is-open")) {
        handle();
      }
    }
  });
});

observer.observe(target, {
  attributes: true,
  attributeFilter: ["class"]
});
  }
}, 200);

function handle(){
  const target = document.querySelector('[name="checkout"]');
  if (target) {
    const prev = target.previousElementSibling;

    const isAlreadyInserted = prev &&
      prev.tagName.toLowerCase() === 'button' &&
      prev.classList.contains('bss-checkout')

    if (!isAlreadyInserted) {
      target.insertAdjacentHTML('beforebegin', `<button class="btn bss-checkout" style="
    width: 100%;
">Checkout</button>`);
      target.style.display = 'none';
    }
    BSS_B2B.observer.cartSubject.listenCartCheckout()
  }
}

